
export const IconAsset = {
    BILISLogo: require('../assets/icons/bilis_logo.png'),
    Loading: require('../assets/icons/loading.gif')
}